export default __webpack_public_path__ + "static/media/art-1-ph-test.4cf78ac5.jpg";